// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectExternalLinkMessage } from '@shared/utils/DirectMessages/DirectMessagesImport';
export class ExternalLinkMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new DirectExternalLinkMessage();
        const factory = FieldsFactory;
        const len = fieldSet.Count();
        for (let i = 0; i < len; i++) {
            const fixField = fieldSet.fieldSet[i];
            if (fixField.FieldId === 0) {
                continue;
            }
            switch (fixField.FieldId) {
                case factory.FIELD_ID:
                    message.Id = fixField.Value;
                    break;
                case factory.FIELD_NAME:
                    message.Name = fixField.Value;
                    break;
                case factory.FIELD_EXTERNAL_LINK_URL:
                    message.Url = fixField.Value;
                    break;
                case factory.FIELD_EXTERNAL_LINK_CLIENT_USE_INTERNAL_BROWSER:
                    message.UseInternalBrowser = fixField.Value;
                    break;
                case factory.FIELD_EXTERNAL_RESOURCE:
                    message.ExternalResource = fixField.Value;
                    break;
                case factory.FIELD_EXTERNAL_LINK_PARAMETERS:
                    message.ExternalLinkParameters = fixField.Value;
                    break;
                case factory.FIELD_EXTERNAL_LINK_WEBCON_DARK:
                    message.ExternalLinkWebContentDark = fixField.Value;
                    break;
                case factory.FIELD_EXTERNAL_LINK_WEBCON_LIGHT:
                    message.ExternalLinkWebContentLight = fixField.Value;
                    break;
            }
        }
        return [message];
    }
}
